import { Outlet } from 'react-router';

const App: React.FC = () => <Outlet />;

export default App;
